const alias = 'ROLE';

export const GET_ROLES_REQUEST = `GET_${alias}S_REQUEST`;
export const GET_ROLES_SUCCESS = `GET_${alias}S_SUCCESS`;
export const GET_ROLES_FAILURE = `GET_${alias}_FAILURE`;
export const GET_ROLES_CLEAR = `GET_${alias}S_CLEAR`;
